import React, { useEffect } from 'react';
import type { FieldValues, Path } from 'react-hook-form';
import type { ExtendedUseFormReturn } from './useFormHooks';

interface UseValidateAutoCompleteProps<T extends FieldValues> {
  formMethods: ExtendedUseFormReturn<T>;
  relevantFields?: string[];
  isDisableValidateAutoComplete?: boolean;
  setIsDisableValidateAutoComplete?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const useValidateAutoComplete = <T extends FieldValues>({
  formMethods,
  relevantFields,
  isDisableValidateAutoComplete,
  setIsDisableValidateAutoComplete,
}: UseValidateAutoCompleteProps<T>) => {
  const { watch, getValues } = formMethods;
  const watchAllFields = watch();
  const oldFieldsValues = React.useRef(getValues());

  useEffect(() => {
    if (isDisableValidateAutoComplete && setIsDisableValidateAutoComplete) {
      return;
    }
    Object.keys(watchAllFields).forEach((key) => {
      const target = key;
      if (
        watchAllFields[target] !== oldFieldsValues.current[target] &&
        relevantFields?.includes(target as string)
      ) {
        const input = document.getElementById(target as string);

        if (input && document.activeElement !== input) {
          // check that target is not null or undefined
          const targetValue = watchAllFields[target];

          if (
            targetValue !== null &&
            targetValue !== undefined &&
            targetValue !== '' &&
            !(
              typeof targetValue === 'object' &&
              targetValue?.title === '' &&
              targetValue?.value === ''
            )
          ) {
            formMethods.trigger(target as Path<T>);
          }
        } else if (
          input &&
          document.activeElement === input &&
          formMethods.formState.errors[target]?.message
        ) {
          formMethods.trigger(target as Path<T>);
        }
      }
    });

    oldFieldsValues.current = { ...watchAllFields };
  }, [watchAllFields, formMethods, relevantFields]);
};
